export default __webpack_public_path__ + "static/media/21_eye.94dd542d.JPG";